import { render, staticRenderFns } from "./TopMiddleCmp.vue?vue&type=template&id=08e1aa87&scoped=true"
import script from "./TopMiddleCmp.vue?vue&type=script&lang=js"
export * from "./TopMiddleCmp.vue?vue&type=script&lang=js"
import style0 from "./TopMiddleCmp.vue?vue&type=style&index=0&id=08e1aa87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1aa87",
  null
  
)

export default component.exports